import React from "react";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/Login"; // make sure this file exists
import AdminDashboard from "./pages/AdminDashboard";
import UserList from "./pages/UserList";
import AddNewUserPage from "./pages/Add_User";
import SentinelUserList from "./pages/SentinelUser_List";
import SentinelAddUser from "./pages/SentinelAdd_User";
import AddIncidents from "./pages/AddIncidents";
import RouteMaster from "./pages/Create_Route";
import RouteList from "./pages/RouteList";
import RouteAllocations from "./pages/RouteAllocation";
import AdminRouteTracking from "./pages/AdminRouteTracking";
import EscortMaster from "./pages/Create_Escort";
import EscortList from "./pages/Escort_list";
import EscortLiveTracking from "./pages/EscortLiveTracking";
import SentinelRouteList from "./pages/Sentinel_Route_List";
import SentinelAddRoute from "./pages/SentinelAddRoute";
import SentinelRouteAllocations from "./pages/Sentinel_Route_Allocation";
import SentinelRouteTracking from "./pages/SentinelRouteTracking";
import SentinelEscortList from "./pages/Sentinel_Escort_List";
import SentinelAddEscort from "./pages/SentinelAddEscort";
import SentinelEscortLiveTracking from "./pages/SentinelEscortLiveTracking";
import InstallationModule from "./pages/InstallationModule";
import Summaries from "./pages/Summaries";
import ExportModule from "./pages/ExportModule";
import CustomReports from "./pages/CustomReport";
import Analytics from "./pages/AnalyticsReport";
import SentinelReports from "./pages/SentinelReports";
import InCampusPage from "./pages/InCampusPage";
import PermissionModules from "./pages/PermissionModules";
import IncidentTypeAllocation from "./pages/IncidentPer";
import SentinelGuardList from "./pages/Sentinel_Incident";
import PatrolQRCodePage from "./pages/PatrolQrCode";
import SentinelQRCodePage from "./pages/Sentinel_qr";
import GuardLogin from "./pages/GuardLogin";
import SentinelPermissionModules from "./pages/SentinelPermissionModule";
import AccountDeletionRequest from "./pages/Account_deletion";
import InCampusList from "./pages/Incampus_list";
import SentinelAttendanceDashboard from "./pages/SentinelAttendanceDashboard";
import CreatePlace from "./pages/create_place";
import PlaceList from "./pages/place_list";
import PlaceAllocationList from "./pages/PlaceAllocation";
import RegisteredDevicesPage from "./pages/DeviceRegister";



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin/" element={<Login />} />
        <Route path='/dashboard' element={<AdminDashboard/>}/>
        <Route path='/user_list' element={<UserList/>}/>
        <Route path='/add_user' element={<AddNewUserPage/>}/>
        <Route path='/sentinel_user_list' element={<SentinelUserList/>}/>
        <Route path='/sentinel_add_user' element={<SentinelAddUser/>}/>
        <Route path='/add_incidents' element={<AddIncidents/>}/>
        <Route path='/create_route' element={<RouteMaster/>}/>
        <Route path='/route_list' element={<RouteList/>}/>
        <Route path="/route_allocation" element={<RouteAllocations/>}/>
        <Route path='/admin_route_tracking' element={<AdminRouteTracking/>}/>
        <Route path='/escort_master' element={<EscortMaster/>}/>
        <Route path='/escort_list' element={<EscortList/>}/>
        <Route path='/escort_live_tracking' element={<EscortLiveTracking/>}/>
        <Route path='/sentinel_route_list' element={<SentinelRouteList/>}/>
        <Route path='/sentinel_add_Route' element={<SentinelAddRoute/>}/>
        <Route path="/sentinel_route_allocation" element={<SentinelRouteAllocations/>}/>
        <Route path='/sentinel_route_tracking' element={<SentinelRouteTracking/>}/>
        <Route path="/sentinel_escort_list" element={<SentinelEscortList/>}/>
        <Route path="/sentinel_add_escort" element={<SentinelAddEscort/>}/>
        <Route path='/sentinel_escort_live_tracking' element={<SentinelEscortLiveTracking/>}/>
        <Route path="/installation" element={<InstallationModule/>}/>
        <Route path="/summaries" element={<Summaries/>}/>
        <Route path="/export" element={<ExportModule/>}/>
        <Route path='/custom' element={<CustomReports/>}/>
        <Route path="/analytics" element={<Analytics/>}/>
        <Route path="/sentinel_reports" element={<SentinelReports/>}/>
        <Route path='/incampus' element={<InCampusPage/>}/>
        <Route path='/incampus_list' element={<InCampusList/>}/>
        <Route path='/sentinel_dashboard' element={<SentinelAttendanceDashboard/>}/>
        <Route path='/permission_modules' element={<PermissionModules/>}/>
        <Route path='/incident_per' element={<IncidentTypeAllocation/>}/>
        <Route path='/sentinel_incident' element={<SentinelGuardList/>}/>
        <Route path="/patrol-qr" element={<PatrolQRCodePage/>}/>
        <Route path="/sentinel-qr" element={<SentinelQRCodePage/>}/>
        <Route path='/create_place' element={<CreatePlace/>}/>
        <Route path='/place_list' element={<PlaceList/>}/>
        <Route path="/" element={<GuardLogin/>}/>
        <Route path='/sentinel_guard_per' element={<SentinelPermissionModules/>}/>
        <Route path='/account-deletion' element={<AccountDeletionRequest/>}/>
        <Route path='/device_register' element={<RegisteredDevicesPage/>}/>
        <Route
    path="/place_allocation/:routeId"
    element={<PlaceAllocationList />}
/>


       
      </Routes>
    </Router>
  );
}

export default App;